import { FC } from "react";
import { useResourceRegister } from "@/utils/resourceRegister";

const DatabaseResourceRegister: FC = () => {
  useResourceRegister({ name: 'databases' })
  useResourceRegister({ name: 'backup-schedule' })
  useResourceRegister({ name: 'database-policy-override' })
  useResourceRegister({ name: 'database-clone' })
  return (
    null
  )
}

export default DatabaseResourceRegister;
